const vehicleDetailFacets = [
    'SubModelID',
    'EngineBaseID',
    'AspirationID',
    'BedLengthID',
    'BedTypeID',
    'BodyNumDoorsID',
    'BodyTypeID',
    'BrakeABSID',
    'BrakeSystemID',
    'CylinderHeadTypeID',
    'DriveTypeID',
    'EngineDesignationID',
    'EngineMfrID',
    'EngineVersionID',
    'EngineVINID',
    'FrontBrakeTypeID',
    'FrontSpringTypeID',
    'FuelDeliverySubTypeID',
    'FuelDeliveryTypeID',
    'FuelSystemControlTypeID',
    'FuelSystemDesignID',
    'FuelTypeID',
    'IgnitionSystemTypeID',
    'MfrBodyCodeID',
    'PowerOutputID',
    'RearBrakeTypeID',
    'RearSpringTypeID',
    'SteeringSystemID',
    'SteeringTypeID',
    'TransElecControlledID',
    'TransmissionControlTypeID',
    'TransmissionMfrID',
    'TransmissionMfrCodeID',
    'TransmissionNumSpeedsID',
    'TransmissionTypeID',
    'ValvesPerEngineID',
    'WheelBaseID',
];
const strictEngineFacets = ['EngineFamilyID', 'EngineSizeID'];

function selectedId(document, id) {
    const raw = String(document.getElementById(id)?.value || '').trim();
    const value = Number(raw);
    return /^\d+$/.test(raw) && Number.isSafeInteger(value) && value > 0 ? value : null;
}

export function readAutocompleteVehicleFilter(document) {
    const baseVehicleId = selectedId(document, 'BaseVehicleID');
    if (baseVehicleId === null) return undefined;

    const clauses = [`(BaseVehicleID = ${baseVehicleId} OR BaseVehicleID = 0)`];
    for (const facet of vehicleDetailFacets) {
        const value = selectedId(document, 'vehicle' + facet);
        if (value !== null) clauses.push(`(${facet} = ${value} OR ${facet} = 0)`);
    }
    for (const facet of strictEngineFacets) {
        const value = selectedId(document, 'vehicle' + facet);
        if (value !== null) clauses.push(`${facet} = ${value}`);
    }
    return clauses.join(' AND ');
}

export const AUTOCOMPLETE_VEHICLE_CHANGED = 'autocomplete-vehicle-changed';

export function syncAutocompleteVehicleFacet(document, facet, value) {
    if (!vehicleDetailFacets.includes(facet) && !strictEngineFacets.includes(facet)) return;
    const raw = String(value).trim();
    const id = Number(raw);
    if (!/^\d+$/.test(raw) || !Number.isSafeInteger(id) || id <= 0) return;
    let input = document.getElementById('vehicle' + facet);
    if (input?.value === String(id)) return;
    if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.id = 'vehicle' + facet;
        document.body.append(input);
    }
    input.value = String(id);
    document.dispatchEvent(new document.defaultView.Event(AUTOCOMPLETE_VEHICLE_CHANGED));
}
